export default __webpack_public_path__ + "static/media/LogoTransfer.06d33944.svg";